import React from 'react';
import { CHECKOUT_MESSAGES } from '../../constants/checkout';

/** Prévia visual da plataforma no checkout (PNG com fundo transparente, sem moldura colorida). */
const CheckoutPlatformPreview: React.FC = () => {
  const { platform } = CHECKOUT_MESSAGES;

  return (
    <section
      className="mb-6 w-full max-w-full rounded-2xl border border-[#D8D1F0] bg-white shadow-sm"
      aria-label={platform.sectionLabel}
    >
      <div className="border-b border-[#E8E4F4] bg-gradient-to-r from-[#F7F4FF] to-white px-4 py-2.5">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#5C528A]">{platform.eyebrow}</p>
        <p className="text-sm font-medium text-gray-800">{platform.title}</p>
      </div>

      <div className="p-3 sm:p-4">
        <img
          src="/assets/checkout/plataforma-preview.png"
          alt={platform.imageAlt}
          className="mx-auto h-auto w-full max-w-full bg-transparent object-contain object-center"
          loading="lazy"
        />
        <p className="mt-3 text-center text-xs leading-relaxed text-gray-600">{platform.caption}</p>
      </div>
    </section>
  );
};

export default CheckoutPlatformPreview;
